export default __webpack_public_path__ + "static/media/UbuntuMono-Italic.b6769d45.ttf";